<template>
  <v-container v-if="sleuthConfig">
    <div v-if="activeSlugs.length > 0" class="text-h6 text-left">Variable Slugs</div>
    <v-row>
      <v-col>
        <v-chip v-for="slug in activeSlugs" :key="slug.value"
                class="ma-2"
                color="green"
                text-color="white"
                small
                @click="insertSlug(slug.name)"
        >
          {{ slug.name }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
            outlined
            name="repostMsgTemplate"
            label="Repost Message Template"
            v-model="sleuthConfig.repost_response_template"
            @click="setActiveTextArea('repostMsgTemplate')"
            ref="repostMsgTemplate"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
            outlined
            name="ocMsgTemplate"
            label="CC Message Template"
            v-model="sleuthConfig.oc_response_template"
            @click="setActiveTextArea('ocMsgTemplate')"
            ref="ocMsgTemplate"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
            outlined
            name="reportMsgTemplate"
            label="Report Message Template"
            v-model="sleuthConfig.report_msg"
            @click="setActiveTextArea('reportMsgTemplate')"
            ref="reportMsgTemplate"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn large block color="primary" @click="saveOnClick" :loading="saving">Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";

const MonitoredSubRepo = RepositoryFactory.get('monitored')
export default {
  name: "MessageTemplates",
  props: {
    subredditName: String
  },
  data: () => ({
    activeTextArea: null,
    activeSlugs: [],
    sleuthConfig: null,
    saving: false,
    // TODO - These needs to be moved to common file
    botCommentSlugs: [
      {name: 'Total Searched', value: '{total_searched}', allowedBotComment: true, allowedReportMsg: false},
      {name: 'Search Time', value: '{search_time}', allowedBotComment: true, allowedReportMsg: false},
      {name: 'Total Matches', value: '{match_count}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Post Type', value: '{post_type}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'This Subreddit', value: '{this_subreddit}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Times Word', value: '{times_word}', allowedBotComment: true, allowedReportMsg: false},
      {name: 'Short Link', value: '{post_shortlink}', allowedBotComment: true, allowedReportMsg: false},
      {name: 'Closest Match Subreddit', value: '{closest_sub}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Closest Match URL', value: '{closest_url}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Closest Match Shortlink', value: '{closest_shortlink}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Closest Match %', value: '{closest_percent_match}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Closest Match Created', value: '{closest_created_at}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Oldest Match Created', value: '{oldest_created_at}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Oldest Match Shortlink', value: '{oldest_shortlink}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Oldest Match %', value: '{oldest_percent_match}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Oldest Match Subreddit', value: '{oldest_sub}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Newest Match Created', value: '{newest_created_at}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Newest Match Shortlink', value: '{newest_shortlink}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Newest Match %', value: '{newest_percent_match}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'Newest Match Subreddit', value: '{newest_sub}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'List of Matches', value: '{match_list}', allowedBotComment: true, allowedReportMsg: false},
      {name: 'Author', value: '{post_author}', allowedBotComment: true, allowedReportMsg: true},
      {name: 'New Line', value: '\n', allowedBotComment: true, allowedReportMsg: false}
    ]
  }),
  methods: {
    getSleuthConfig() {
      console.log('Loading Subreddit Sleuth Config')
      return MonitoredSubRepo.getMonitoredSubConfig({params: {token: this.$store.getters.token}}, this.subredditName)
          .then(res => {
            this.sleuthConfig = {
              repost_response_template: res.data.repost_response_template,
              report_msg: res.data.report_msg,
              oc_response_template: res.data.oc_response_template,
              name: res.data.name
            }
          })
    },
    setActiveSlugs() {
      this.activeSlugs = [];
      if (this.activeTextArea === 'repostMsgTemplate' || this.activeTextArea === 'ocMsgTemplate') {
        this.activeSlugs = this.botCommentSlugs.filter(i => i.allowedBotComment)
      } else if (this.activeTextArea === 'reportMsgTemplate') {
        this.activeSlugs = this.botCommentSlugs.filter(i => i.allowedReportMsg)
      }
    },
    getSelectedTextAreaValue() {
      if (this.activeTextArea === 'repostMsgTemplate') {
        return this.sleuthConfig.repost_response_template || ''
      } else if (this.activeTextArea === 'reportMsgTemplate') {
        return this.sleuthConfig.report_msg || ''
      } else {
        return ''
      }
    },
    setSelectedTextAreaValue(newValue) {
      if (this.activeTextArea === 'repostMsgTemplate') {
        this.sleuthConfig.repost_response_template = newValue
      } else if (this.activeTextArea === 'reportMsgTemplate') {
        this.sleuthConfig.report_msg = newValue
      }
    },
    setActiveTextArea(textName) {
      this.activeTextArea = textName;
      this.setActiveSlugs();
    },
    insertSlug(slugName) {
      let slug = this.activeSlugs.find(i => i.name === slugName);
      const el = document.getElementsByName(this.activeTextArea)[0];
      let cursorPos = el.selectionEnd;
      let currentText = this.getSelectedTextAreaValue();
      let newText = `${currentText.substring(0, cursorPos)}${slug.value}${currentText.substring(cursorPos, currentText.length)}`
      this.setSelectedTextAreaValue(newText);
    },
    saveOnClick() {
      this.saving = true;
      MonitoredSubRepo.updateMonitoredSub(this.sleuthConfig, {params: {token: this.$store.getters.token}})
          .then(res => {
            this.saving = false;
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
            } else {
              this.$emit('on-alert', {color: 'success', message: 'Settings Saved'})
            }
          })
    },
  },
  mounted() {
    this.getSleuthConfig();
  }
}
</script>

<style scoped>

</style>
